import { render, staticRenderFns } from "./singDialog.vue?vue&type=template&id=631a4094&scoped=true"
import script from "./singDialog.vue?vue&type=script&lang=js"
export * from "./singDialog.vue?vue&type=script&lang=js"
import style0 from "./singDialog.vue?vue&type=style&index=0&id=631a4094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a4094",
  null
  
)

export default component.exports